<template id="modal-template" lang="pug">
    div.modal-mask(@click="close", transition="modal")
        div.modal-container(@click.stop="", v-bind:class="{'fix-top': isMobile}")
            div.modal-header(v-if="!isMobile")
                slot(name="header")
            div.modal-body
                slot(name="body")
            div.modal-footer
                slot(name="footer")
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'modal',
    computed: {
        ...mapGetters(['isMobile'])
    },
    methods: {
        close() {
            this.$parent.close()
        }
    },
    mounted() {
        document.addEventListener('keydown', e => {
            if (this.$parent.showModal && e.keyCode == 27) {
                this.$parent.close()
            }
        })
    }
}
</script>

<style lang="sass">
    @import "../../sass/mixin/color"
    @import "../../sass/mixin/flex"

    .pwa-modal
        .modal-body
            padding: 8px!important

    .modal-mask
        position: fixed
        z-index: 9998
        top: 0
        left: 0
        width: 100%
        height: 100%
        background-color: rgba(50,50,50, 0.75)
        display: flex
        align-items: center
        justify-content: center

        .modal-container
            animation: animatetop 0.5s backwards
            display: block
            position: absolute
            z-index: 9999
            width: 600px
            max-width: 100vw
            max-height: 100vh
            &.fix-top
                top: 0

            .modal-header
                background-color: $c-g50 //falback color. better to be declared
                height: 96px
                @include flex-center
                padding-left: 0
                border-radius: 4px 4px 0 0
                box-shadow: 0 0 8px rgba(0,0,0,0.5)
                h3
                    margin: 0 0 0 32px
                    font-weight: 300
                    font-size: 32px
                    text-transform: uppercase

            .modal-body
                min-height: calc(100vh - 96px * 3 - 48px)
                max-height: calc(100vh - 96px - 48px)
                overflow-y: auto
                background-color: $c-g245
                padding: 16px 32px
                box-shadow: 0 0 8px rgba(0,0,0,0.5)
                h4
                    font-size: 20px
                    font-weight: 800
                    color: #2980b9
                    text-transform: uppercase
                    border-bottom: 3px solid #2980b9
                    margin: 16px 0

                .form-wrapper
                    .form-label
                        border: none
                    .validation-message
                        background-color: $c-tabe-red
                        padding: 2px 6px
                        border-radius: 2px
                        font-size: 13px
                        color: white
                    input
                        height: 48px
                    input.multiselect__input
                        height: 32px
                    input, textarea, .multiselect__tags
                        border: 2px solid $c-g215
                        border-radius: 4px
                    input:focus, textarea:focus, .multiselect__tags:focus
                        color: $c-tabe-green
                        border-color: $c-tabe-green
                    input:focus ~ label, .input-filled, textarea:focus ~ label
                        color: $c-tabe-green
                    span
                        font-size: 18px
                    .multiselect__input, .multiselect__single
                        border: 0px solid $c-g215

                .favorite-models
                    display: flex
                    align-items: center
                    flex-wrap: wrap
                    margin-top: 16px
                    i.ic-bookmark
                        font-size: 24px
                        color: $c-tabe-yellow
                        margin-right: 4px

            .modal-footer
                height: 48px
                button
                    height: 48px
                    min-width: 50%
                    border: none
                    color: white
                    font-size: 18px
                    font-weight: 300
                    cursor: pointer
                    &.button-invalid
                        background-color: $c-g130
                        &:hover
                            background-color: $c-g130
                            border-radius: 0!important
                    &.button-cancel
                        background-color: $c-tabe-red
                        &:hover
                            background-color: darken($c-tabe-red, 3%)
                    &.button-validate
                        background-color: $c-tabe-blue
                        &:hover
                            background-color: darken($c-tabe-blue, 3%)
                    &.left:hover
                        border-radius: 0 0 0 16px
                    &.right:hover
                        border-radius: 0 0 16px 0

            .modal-default-button
                float: right

        /*
         * The following styles are auto-applied to elements with
         * transition="modal" when their visibility is toggled
         * by Vue.js.
         *
         * You can easily play with the modal transition by editing
         * these styles.

        .modal-enter, .modal-leave-active
            opacity: 0

        .modal-enter .modal-container, .modal-leave-active .modal-container
            -webkit-transform: scale(1.1)
            transform: scale(1.1)
            -webkit-transition: all 3s ease-in
            -moz-transition: all 3s ease-in
            -o-transition: all 3s ease-in
            -ms-transition: all 3s ease-in
</style>
